module.exports = __webpack_public_path__ + "images/help/video-preview-files-5cd6c2844b9bd199c52424f4c5fa3897.jpg";